// components/RedeemCode.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';
import { apiCall } from "../utils/api";
import { APP_CONFIG } from "../app-config";

const COLORS = APP_CONFIG.colors;

const redeemAmounts = [10, 50, 100, 250, 500, 1000];

function RedeemCode() {
    const navigate = useNavigate();
    const [amount, setAmount] = useState("");
    const [error, setError] = useState("");
    const [parsedData, setParsedData] = useState(JSON.parse(localStorage.getItem("credentials")));

    const handlePay = async () => {
        if (!amount || Number(amount) <= 0) {
            setError("Please select or enter amount");
            return;
        }

        navigate("/payment-confirmation", {
            state: {
                service: "Redeem Code Recharge",
                operator: 'Google Play Redeem Code',
                operator_id: '114',
                logo: 'https://rechargemyphone.in/app-v3/assets/playstore.png',
                number: parsedData?.mobile || "",
                amount: amount,
                consumerName: parsedData?.name,
                serviceSpecificData: {
                    range: {
                        min_amount: '10',
                        max_amount: '3000'
                    },
                    form: {
                        param1: parsedData?.mobile || "9854777908"
                    }
                }
            }
        });
    };


    return (
        <div className="space-y-4">
            {/* Buy Redeem Code Section */}
            <div
                className="rounded-2xl p-4 md:p-6"
                style={{
                    background: COLORS.bgColor,
                    boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                    border: `1px solid ${COLORS.borderColor}`,
                }}
            >
                <h3 className="text-lg font-semibold mb-4" style={{ color: COLORS.textPrimary }}>
                    Buy Google Play Redeem Code
                </h3>

                <div className="mb-4 p-3 rounded-xl" style={{ background: `${COLORS.primaryColor}10` }}>
                    <p className="text-sm" style={{ color: COLORS.textSecondary }}>
                        Select amount and purchase a Google Play redeem code
                    </p>
                </div>

                {/* Amount Selection */}
                <div className="mb-6">
                    <label
                        className="block text-sm font-semibold mb-3"
                        style={{ color: COLORS.textPrimary }}
                    >
                        Select Amount
                    </label>

                    {/* Amount Grid */}
                    <div className="grid grid-cols-6 gap-2.5 mb-4">
                        {redeemAmounts.map((amt) => (
                            <button
                                key={amt}
                                onClick={() => { setAmount(String(amt)); setError(""); }}
                                className="p-3 rounded-xl text-[15px] font-bold cursor-pointer transition-all duration-200 active:scale-95"
                                style={{
                                    border: `1.5px solid ${Number(amount) === amt ? COLORS.primaryColor : COLORS.borderColor}`,
                                    background: Number(amount) === amt ? `${COLORS.primaryColor}15` : COLORS.surfaceColor,
                                    color: Number(amount) === amt ? COLORS.primaryColor : COLORS.textPrimary,
                                }}
                            >
                                ₹{amt}
                            </button>
                        ))}
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                            <label className="block text-sm font-medium mb-2" style={{ color: COLORS.textSecondary }}>
                                Enter amount
                            </label>
                            {/* Custom Amount Input */}
                            <input
                                type="number"
                                placeholder="Or enter custom amount (₹10 - ₹3000)"
                                value={amount}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === '' || Number(val) >= 0) {
                                        setAmount(val);
                                        setError("");
                                    }
                                }}
                                className="w-full p-3.5 rounded-xl text-[15px] font-semibold outline-none transition-colors duration-200"
                                style={{
                                    border: `1px solid ${error ? COLORS.errorColor || '#EF4444' : COLORS.borderColor}`,
                                    background: COLORS.surfaceColor,
                                    color: COLORS.textPrimary,
                                }}
                                min="10"
                                max="3000"
                            />

                            {error && (
                                <div
                                    className="text-xs mt-2 font-semibold"
                                    style={{ color: COLORS.errorColor || '#EF4444' }}
                                >
                                    {error}
                                </div>
                            )}
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-2" style={{ color: COLORS.textSecondary }}>
                                Action
                            </label>
                            {/* Buy Button */}
                            <button
                                onClick={handlePay}
                                disabled={!amount || Number(amount) <= 0}
                                className="w-full py-3.5 rounded-xl font-semibold flex items-center justify-center gap-2 transition-all duration-200 hover:scale-[1.02] active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                                style={{
                                    background: COLORS.primaryColor,
                                    color: COLORS.textOnPrimary,
                                    boxShadow: `0 4px 12px ${COLORS.primaryColor}33`,
                                }}
                            >
                                Buy Recharge Code
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <style>
                {`
                    @keyframes spin {
                        to { transform: rotate(360deg); }
                    }
                    .animate-spin {
                        animation: spin 1s linear infinite;
                    }
                    .hover\\:scale-\\[1\\.02\\]:hover {
                        transform: scale(1.02);
                    }
                    .active\\:scale-95:active {
                        transform: scale(0.95);
                    }
                `}
            </style>
        </div>
    );
}

export default RedeemCode;